import _get from 'lodash/get'
import { fromJS } from 'immutable'
import {
  setFiltersPlacementsData,
  setFiltersDateRangeData,
  setFiltersProcessing,
  setFiltersError,
  GET_FILTERS_DATA,
} from './actions'
import {
  getPlacements,
  getDateRangeValues,
} from '..'

const log = console

async function getFiltersDataHandler ({ store }) {
  const { config, auth } = store.getState()

  try {
    store.dispatch(setFiltersProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
    }
    if (auth.get('processing') !== false) {
      return
    }

    let placements = await getPlacements(options)
    placements = fromJS(_get(placements, 'placements'))
    store.dispatch(setFiltersPlacementsData({
      data: placements,
    }))

    let dateRangeFilterValues = await getDateRangeValues(options)
    dateRangeFilterValues = fromJS(_get(dateRangeFilterValues, 'dateRangeFilterValues'))
    store.dispatch(setFiltersDateRangeData({
      data: dateRangeFilterValues,
    }))
  } catch (error) {
    log.error(error, 'Error getting merchandising placements data.')
    store.dispatch(setFiltersError({
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_FILTERS_DATA:
      getFiltersDataHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
